import { Form, Select } from "antd";
import { TextService } from "../../Services/TextService";
import { HelpModal } from "../Page/HelpModal";

export const BookySelectDropDown = (props: any) => {
    const GetText = TextService.GetText;

    const handleChange = (value: { value: string; label: React.ReactNode }) => {
        props.handleChange?.(value);
    };

    const rules: any = [];
    if (props.req) {
        rules.push({
            required: true,
            message: props.requiredMessage || GetText("EditMember_Mandatory"),
        });
    }

    return (
        <Form.Item
            label={props.label
                ? <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <span>{props.label}</span>
                    {props.help && (
                        <HelpModal title={props.helpTitle}>
                            {props.help}
                        </HelpModal>
                    )}
                  </div>
                : undefined}
            colon={!!props.label}
            name={props.name}
            rules={rules}
            style={!props.label ? { margin: 0 } : undefined}
        >
            <Select
                placeholder={props.placeholder}
                style={props.style}
                allowClear={props.allowClear}
                options={props.options}
                value={props.value}
                onChange={handleChange}
                showSearch={props.showSearch}
                filterOption={
                    props.showSearch
                        ? (input, option) =>
                            (option?.label ?? "")
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        : undefined
                }
            />
        </Form.Item>
    );
};